module.exports = __webpack_public_path__ + "img/78_38.5c281c25.png";